module.exports = __webpack_public_path__ + "img/Group_42229@2x.d70c4c89.png";